import { Avatar, type AvatarProps } from '@mui/material'
import { useQuery } from '@hapana/shared/web/services/gqty'
import useSiteStore from '_stores/site.store'

interface ClientAvatarProps extends Omit<AvatarProps, 'src'> {
  clientId: string
  initials: string
}

const ClientAvatar = ({ clientId, initials, ...avatarProps }: ClientAvatarProps) => {
  const siteId = useSiteStore((state) => state.currentSite?.siteId)
  const query = useQuery({ suspense: false })

  const profileImageUrl =
    clientId && siteId
      ? query.client({ id: clientId, siteId })?.client?.profileImage?.({
          input: { type: 'thumbnail', format: 'webp' },
        })?.url
      : undefined

  return (
    <Avatar src={profileImageUrl ?? undefined} {...avatarProps}>
      {initials}
    </Avatar>
  )
}

export default ClientAvatar
